import React from 'react';
import { connect } from 'react-redux';

import { StoreLocatorSearch } from './store-locator-search';
import { StoreLocatorMap } from './store-locator-map';
import { MobileTabs, MobileTab } from './mobile-tabs';
import { Store } from './store';
import { StoreList } from './store-list';
import { StoreImage } from '../store/store-image';
import { MobileExpandedStore } from './mobile-expanded-store';
import { StoreLocatorLocationWarningYodel } from '../store-locator-location-warning';

import { isMobileScreen } from '../map-utils';
import {setLocation, setCurrentLocation, loadStores, setOrigin, setVisibleStores,
  setSelectedStore, getVisibleStores} from '../data-store';

const mapStateToProps = state => {
  return {
    origin: state.origin,
    stores: state.stores,
    visibleStores: getVisibleStores(state.stores, state.bounds),
    adjustVisibleStores: state.adjustVisibleStores,
    error: state.error,
    bounds: state.bounds,

  };
};

export class StoreLocator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMobileStoreDetail: false,
      showExpandedStore: false,
      searchAsMapMoves: true,
      postcode: this.props.postcode,
      mapVisible: false,
      searchFilter: ["paypoint", "in_post_locker"].includes(this.props.searchFilter) ? [this.props.searchFilter] : ["in_post_locker", "paypoint"],
      lastSearchType: null
    };

    this.handleSetLocation = this.handleSetLocation.bind(this);
    this.handleSetCurrentLocation = this.handleSetCurrentLocation.bind(this);
    this.handleMapCreated = this.handleMapCreated.bind(this);
    this.handleMoveEnd = this.handleMoveEnd.bind(this);
    this.handleBoundsChanged = this.handleBoundsChanged.bind(this);
    this.handleStoreSelected = this.handleStoreSelected.bind(this);
    this.isAutoGeolocateRequested = this.isAutoGeolocateRequested.bind(this);
    this.handleMobileThumbnailClicked = this.handleMobileThumbnailClicked.bind(this);
    this.toggleExpandedStore = this.toggleExpandedStore.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  handleFilterChange(filter) {
    this.setState({ searchFilter: filter }, () => {
      switch (this.state.lastSearchType) {
        case "setLocation":
          this.setLocation(this.state.postcode);
          break;
        case "setCurrentLocation":
          this.setCurrentLocation();
          break;
        case "handleMoveEnd":
          this.handleMoveEnd(this.props.origin, this.props.bounds, filter);
          break;
        }
    });
  }  

  toggleExpandedStore() {
    this.setState({showExpandedStore: !this.state.showExpandedStore});
  }

  handleMapCreated() {
    if (this.props.postcode) {
      this.setLocation(this.props.postcode);
    } else if (this.props.isMobileDevice || this.isAutoGeolocateRequested()) {
      this.setCurrentLocation();
    }
  }

  isAutoGeolocateRequested(){
    let url = window.location.href;

    return url.includes("?current_location");
  }

  handleSetLocation(postcode) {
    this.setLocation(postcode);
  }

  handleSetCurrentLocation() {
    this.setCurrentLocation();
  }

  setLocation(postcode) {
    this.setState({lastSearchType: "setLocation"});
    this.hideFlashMessageError();
    this.props.dispatch(setLocation(this.sanitizePostcode(postcode), this.props.isMobileDevice, this.state.searchFilter));
  }

  setCurrentLocation() {
    this.setState({lastSearchType: "setCurrentLocation"});
    this.props.dispatch(setCurrentLocation(this.props.isMobileDevice, this.state.searchFilter));
  }

  sanitizePostcode(postcode) {
    return postcode.replace('/', '')
  }

  handleMoveEnd(center, bounds) {
    if (this.props.origin && (this.state.searchAsMapMoves || this.props.isMobileDevice)) {
      this.setState({lastSearchType: "handleMoveEnd"});
      this.props.dispatch(loadStores({
        center: center,
        bounds: bounds,
        isMobileDevice: this.props.isMobileDevice,
        filter: this.state.searchFilter
      }));
      this.props.dispatch(setOrigin(center));
      this.setState({postcode: `${center.lat.toFixed(6)},${center.lng.toFixed(6)}`});
    }
  }

  handleBoundsChanged(bounds) {
    this.props.dispatch(setVisibleStores(bounds));
  }

  handleStoreSelected(storeId) {
    this.props.dispatch(setSelectedStore(storeId));
  }

  hideFlashMessageError() {
    try {
      let section = document.querySelectorAll(".section-flash-message.-error")[0];

      if(section) {
        section.style.display = 'none';
      }
    } catch(err) {}
  }

  handleMobileThumbnailClicked() {
    this.setState({showMobileStoreDetail: !this.state.showMobileStoreDetail});
  }

  render() {
    let visibleStores = this.props.visibleStores;
    let selectedStoreIndex = this.props.stores.findIndex((store) => store.selected);
    let selectedStore = this.props.stores[selectedStoreIndex];
    return (
      <div className='store-locator-container'>
        <StoreLocatorSearch
          searchFilter={this.state.searchFilter}
          onFilterChange={this.handleFilterChange} 
          postcode={this.state.postcode}
          onSetLocation={this.handleSetLocation}
          onSetCurrentLocation={this.handleSetCurrentLocation}
          isMobile={this.props.isMobileDevice}
          isInPostEnabled={this.props.isInPostEnabled}
          isInPostStoreLocatorRebrandEnabled={this.props.isInPostStoreLocatorRebrandEnabled}
          searchAsMapMoves={(searchAsMapMoves) => this.setState({searchAsMapMoves}) }
        />
        {
          isMobileScreen() &&
            <MobileTabs>
              <MobileTab
                label="List"
                active={!this.state.mapVisible}
                onClick={() => this.setState({mapVisible: false})}
              />
              <MobileTab
                label="Map"
                active={this.state.mapVisible}
                onClick={() => this.setState({mapVisible: true})}
              />
            </MobileTabs>
        }
        <div className='activeArea'></div>
        {this.props.error &&
          <StoreLocatorLocationWarningYodel message={this.props.error} />
        }
        <StoreLocatorMap
          origin={this.props.origin}
          stores={this.props.stores}
          minVisibleStores={this.props.isMobileDevice ? this.props.minVisibleStoresMobile : this.props.minVisibleStoresDesktop}
          maxRadius={this.props.isMobileDevice ? this.props.maxRadiusMobile : this.props.maxRadiusDesktop}
          adjustVisibleStores={this.props.adjustVisibleStores}
          onMapCreated={this.handleMapCreated}
          onMoveEnd={this.handleMoveEnd}
          onBoundsChanged={this.handleBoundsChanged}
          onMarkerSelected={this.handleStoreSelected}
          useOsm={this.props.useOsm}
          osmUrl={this.props.osmUrl}
          collapseMap={this.state.showMobileStoreDetail}
          defaultZoom={this.props.defaultZoom}
          searchAsMapMoves={this.state.searchAsMapMoves}
          isMobileDevice={this.props.isMobileDevice}
          isInPostStoreLocatorRebrandEnabled={this.props.isInPostStoreLocatorRebrandEnabled}
        />
        {this.props.imagesEnabled && this.props.isMobileDevice && selectedStore && selectedStore.store_image_url && visibleStores.length > 0 && this.state.showMobileStoreDetail &&
          (
            <StoreImage imageUrl={selectedStore.store_image_url} />
          )
        }
        {
          ((this.props.isMobileDevice && !this.state.mapVisible) || (!this.props.isMobileDevice && visibleStores.length > 0)) &&
            <StoreList
              origin={this.props.origin}
              stores={visibleStores}
              selectedStore={selectedStore}
              selectedStoreIndex={selectedStoreIndex}
              onStoreSelected={this.handleStoreSelected}
              postcode={this.props.postcode}
              isMobileScreen={isMobileScreen()}
              isMobileDevice={this.props.isMobileDevice}
              imagesAreAllowed={this.props.imagesEnabled}
              showMobileStoreDetail={this.state.showMobileStoreDetail}
              isInPostEnabled={this.props.isInPostEnabled}
              isInPostStoreLocatorRebrandEnabled={this.props.isInPostStoreLocatorRebrandEnabled}
              handleMobileThumbnailClicked={this.handleMobileThumbnailClicked}
              toggleExpandedStore={this.toggleExpandedStore}
              hide={this.props.isMobileDevice && this.state.mapVisible}
            />
        }
        {isMobileScreen && selectedStore && this.state.mapVisible &&
          <ul className="selected-store-mobile">
            <Store
              origin={this.props.origin}
              store={selectedStore}
              storeIndex={selectedStoreIndex}
              postcode={this.props.postcode}
              isMobileDevice={this.props.isMobileDevice}
              showMobileStoreDetail={this.props.showMobileStoreDetail}
              handleMobileThumbnailClicked={this.handleMobileThumbnailClicked}
              toggleExpandedStore={this.toggleExpandedStore}
              selected={true}
              isInPostStoreLocatorRebrandEnabled={this.props.isInPostStoreLocatorRebrandEnabled}
            />
          </ul>
        }
        {this.props.isMobileDevice && this.state.showExpandedStore &&
          <MobileExpandedStore
            store={selectedStore}
            origin={this.props.origin}
            toggleExpandedStore={this.toggleExpandedStore}
            isInPostStoreLocatorRebrandEnabled={this.props.isInPostStoreLocatorRebrandEnabled}
          />
        }
      </div>
    );
  }
}

export default connect(mapStateToProps)(StoreLocator);
